(function () {
    const body = document.body;
    function checkScroll() {
        if (window.scrollY > 30) {
            body.classList.add("scrolled");
        } else {
            body.classList.remove("scrolled");
        }
    }
    checkScroll();
    window.addEventListener("scroll", checkScroll);

    // Cycle through logo variants in a fixed order, advancing on each page load.
    // Nav and footer share the same counter but read from offset positions so they
    // always land on different variants.
    const logoVariants = [1, 2, 3, 4, 5];
    const footerOffset = 2;
    let logoIndex = 0;
    try {
        logoIndex = (parseInt(localStorage.getItem("logoVariantIndex"), 10) || 0) % logoVariants.length;
        localStorage.setItem("logoVariantIndex", String(logoIndex + 1));
    } catch (e) {
        // localStorage unavailable (private mode etc.) — fall back to first variant
    }
    const navVariant = logoVariants[logoIndex];
    const footerVariant = logoVariants[(logoIndex + footerOffset) % logoVariants.length];
    document.querySelectorAll(".logo:not(.logo-footer):not(.no-random)").forEach(function (el) {
        el.classList.add("logo-variant-" + navVariant);
    });
    document.querySelectorAll(".logo.logo-footer:not(.no-random)").forEach(function (el) {
        el.classList.add("logo-variant-" + footerVariant);
    });
})();